// ViewController.js
// Layout-/DOM-Belange der Karte (kein Map-Verhalten): Float, Canvas-Wechsel, Controls.
// Erfährt den aktiven Map-Modus und Map-Operationen ausschließlich über injizierte Getter/Actions
// (Richtung Map→View), ruft also nicht zurück in MapController/TopoMapCore.

import { MapFloatHelper } from "../tools/MapFloatHelper.js";
import { MapCanvasManager } from "../tools/MapCanvasManager.js";
import { mediator } from "../../mediator/mediatorInstance.js";

export class ViewController {
    #isMainActive;
    #isGalleryActive;
    #performMapAction;
    #layoutConnector;
    #globalObjectConnector;
    #getMapInstance;
    #getCurrentCanvas;
    #scheduleTimeout;

    mapFloatHelper;
    mapCanvasManager;

    constructor({ isMainActive, isGalleryActive, performMapAction,
                  getMapInstance, getCurrentCanvas, scheduleTimeout }) {
        this.#isMainActive = isMainActive;
        this.#isGalleryActive = isGalleryActive;
        this.#performMapAction = performMapAction;
        this.#getMapInstance = getMapInstance;
        this.#getCurrentCanvas = getCurrentCanvas;
        this.#scheduleTimeout = scheduleTimeout;

        this.mapFloatHelper = new MapFloatHelper(
            () => document.getElementById('left'),
            () => document.getElementById('topo_footer'),
            () => document.getElementById('left_wrapper'),
            { minHeight: 250, padding: 15 }
        );
        this.mapCanvasManager = new MapCanvasManager("map_canvas", "galleryMapCanvas");
    }

    updateFloat() {
        if (this.#isMainActive()) {
            this.mapFloatHelper.floatMainMap();
        } else if (this.#isGalleryActive()) {
            this.mapFloatHelper.floatGalleryMap();
        }
    }

    switchCanvasToGallery() {
        this.mapCanvasManager.switchToGallery();
    }

    restoreMainCanvas() {
        this.mapCanvasManager.restoreMain();
    }

    setConnectors({ layoutConnector, globalObjectConnector }) {
        this.#layoutConnector = layoutConnector;
        this.#globalObjectConnector = globalObjectConnector;
    }

    onResize() {
        if (this.#isMainActive()) {
            const sticky = this.#layoutConnector.GetMapContainer().parent().hasClass('is-sticky');
            if (sticky) {
                const sTop = $(window).scrollTop();
                const lwOffsetT = $('#left_wrapper #left-sticky-wrapper, #left_wrapper .ui-accordion-content-active').offset().top;
                this.#layoutConnector.GetLWResizeIndicatorsContainer().css({ 'top': lwOffsetT + 4 - sTop });
                this.#layoutConnector.GetLWResizeableContainer().css({ 'top': lwOffsetT - sTop > 0 ? lwOffsetT - sTop : 0 });
            }
        }

        if (this.#isGalleryActive()) {
            $('#galleryMapCanvas .ui-resizable-s').css({
                'position': 'fixed',
                'left': this.#layoutConnector.GetGalleryContentContainer().innerWidth()
            });
        }
    }


    createArchiveToggle({ parent, onToggle, labelText = "ARCHIVES_MORE", checked = false, css = {} } = {}) {
        const container = document.createElement('div');
        container.className = 'topomarker-control';
        Object.assign(container.style, css);

        const label = document.createElement('label');
        label.setAttribute('for', 'cb_topomarker');
        label.textContent = labelText;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = 'cb_topomarker';
        checkbox.className = 'noshadow';
        checkbox.checked = checked;

        checkbox.addEventListener('click', ev => {
            if (typeof onToggle === 'function') { onToggle(ev.target.checked); }
        });

        container.appendChild(label);
        container.appendChild(checkbox);

        // ToDo: ent-hardcodisieren
        document.getElementById(parent).appendChild(container);

        return checkbox;
    }
}
